import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';

class InterviewScheduleDirectoryState {
  store = new DomainStore();
  history;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  async createInterviewSchedule() {
    const {model} = await this.store.post(
      endpoints.INTERVIEW_SCHEDULES.ALL,
      types.INTERVIEW_SCHEDULE
    );

    this.history.push(`/interview-schedules/${model.id}/edit`);
  }

  async deleteInterviewSchedule(model) {
    await this.store.destroy(model);
  }

  customLinksFor(schedule) {
    if (!schedule.hasLink('duplicate')) return [];

    return [
      {
        order: 1,
        text: 'recruiting.interview_schedules.Duplicate',
        translate: true,
        action: s => this.duplicateInterviewSchedule(s)
      }
    ];
  }

  async duplicateInterviewSchedule(schedule) {
    const {model} = await this.store.post(
      endpoints.INTERVIEW_SCHEDULE.DUPLICATE.with(schedule.id),
      types.INTERVIEW_SCHEDULE
    );

    if (model) {
      this.history.push(`/interview-schedules/${model.id}/edit`);
    }
  }
}

export default InterviewScheduleDirectoryState;
